import * as React from 'react'

import { IProps } from './IProps'
import { Container, MatchingText } from './styles'

export const ProductName: React.FC<IProps> = ({ allText, targetText }) => {
  const cleanTargetText: string = targetText.replace(/\W/g, '')

  // TODO: Fix this auto-generated suppression.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pattern = new RegExp(cleanTargetText, 'i')

  const [textBeforeMatch, textAfterMatch] = React.useMemo(() => {
    if (cleanTargetText.trim().length < 2) return [allText]
    return allText.split(pattern)
  }, [allText, cleanTargetText, pattern])

  const targetTextMatches = React.useMemo(() => {
    if (cleanTargetText.trim().length < 2) return null
    return allText.match(pattern)
  }, [allText, cleanTargetText, pattern])

  return (
    <Container>
      {textBeforeMatch}
      {targetTextMatches && <MatchingText>{targetTextMatches[0]}</MatchingText>}
      {textAfterMatch}
    </Container>
  )
}
